import { useState, useEffect, useCallback } from 'react';
import myDriveService, { DirCategory, DriveFile } from '../services/myDriveService';
import { useMessage } from '../../../../contexts/MessageContext';

/**
 * SideNav 樹狀用 — 抓 category 完整 folder list（不跟 prefix 走）。
 * 因為 SideNav 要永遠顯示完整樹，不能跟 useDriveFiles（prefix-scoped）綁，
 * 否則進子目錄後 sibling folders 會消失。
 */
export function useCategoryFolders(dir_category: DirCategory) {
  const { showApiError } = useMessage();
  const [folders, setFolders] = useState<DriveFile[]>([]);

  const reload = useCallback(async () => {
    try {
      const data = await myDriveService.listFiles(dir_category, '');
      setFolders(data.items.filter(f => f.is_directory));
    } catch (err) {
      showApiError(err);
    }
  }, [dir_category, showApiError]);

  useEffect(() => { reload(); }, [reload]);

  return { folders, reload };
}
